import { email } from './email'
import { nullOrUndefined } from './nullOrUndefined'
export const Validate = {
  email,
  nullOrUndefined
}